import { User } from '../../pages/users/types'
import api from '../../services/api'
import { accountService } from '@/services/account-service'
import { accountToUser, userToAccount } from '@/utils/account-mapper'

export type Pagination = {
  page: number
  perPage: number
  total: number
}

export type Sorting = {
  sortBy: keyof User | undefined
  sortingOrder: 'asc' | 'desc' | null
}

export type Filters = {
  isActive: boolean
  search: string
}

export const getUsers = async (filters: Partial<Filters & Pagination & Sorting>) => {
  const { isActive, search } = filters
  //RJA let filteredUsers: User[] = await fetch(api.allUsers()).then((r) => r.json())
  let filteredUsers: User[] = await accountService.read({ id: '' }).then((r) =>
    r.data.payload.items.map((item: any) => {
      return accountToUser(item)
    }),
  )
  filteredUsers = filteredUsers.filter((user) => user.active === isActive)

  if (search) {
    filteredUsers = filteredUsers.filter((user) => user.fullname.toLowerCase().includes(search.toLowerCase()))
  }

  const { page = 1, perPage = 10 } = filters || {}
  return {
    data: filteredUsers,
    pagination: {
      page,
      perPage,
      total: filteredUsers.length,
    },
  }
}

export const addUser = async (user: User) => {
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  return await accountService
    .add(userToAccount(user))
    .then((r) => {
      if (r.data.success) {
        return Promise.resolve(accountToUser(r.data.payload))
      } else {
        throw new Error(r.data.error)
      }
    })
    .catch((e) => {
      throw new Error(e.message)
    })
}

export const signupUser = async (user: User) => {
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  return await accountService
    .signup(userToAccount(user))
    .then((r: any) => {
      if (r.data.success) {
        return Promise.resolve(accountToUser(r.data.payload))
      } else {
        throw new Error(r.data.error)
      }
    })
    .catch((e: any) => {
      let msg = e.message
      if (e.status == 409) {
        msg = 'User already exists'
      }
      throw new Error(msg)
    })
}

export const updateUser = async (user: User): Promise<User> => {
  return await accountService
    .update(userToAccount(user))
    .then((r) => {
      if (r.data.success) {
        return Promise.resolve(accountToUser(r.data.payload))
      } else {
        throw new Error(r.data.error)
      }
    })
    .catch((e) => {
      throw new Error(e.message)
    })

  /*const headers = new Headers()
  headers.append('Content-Type', 'application/json')

  const result = await fetch(api.user(user.id), { method: 'PUT', body: JSON.stringify(user), headers }).then((r) =>
    r.json(),
  )

  if (!result.error) {
    return result
  }

  throw new Error(result.error)
  */
}

export const removeUser = async (user: User) => {
  return await accountService
    .remove(userToAccount(user))
    .then((r) => {
      if (r.data.success) {
        return Promise.resolve(r.data.payload)
      } else {
        throw new Error(r.data.error)
      }
    })
    .catch((e) => {
      throw new Error(e.message)
    })
}

export const uploadAvatar = async (body: FormData) => {
  return fetch(api.avatars(), { method: 'POST', body, redirect: 'follow' }).then((r) => r.json())
}

export const getUserProfile = async (): Promise<void | User> => {
  return await accountService.userInfo().then((r) => {
    if (r.status === 200 && r.data.success) {
      const account = r.data.payload[0]
      return Promise.resolve(
        accountToUser(account),
        /*{
        id: user.id,
        fullname: `${user.person.firstName} ${user.person.lastName}`,
        username: user.login,
        email: user.login,
        role: user.roles[0],
        projects: [],
        avatar: "",
        notes: "",
        active: user.enablement.enabled,
        created_at: user.createdAt
      }*/
      )
    } else {
      if (r.status === 401) {
        //accountService.logout()
      }
      return Promise.reject(r)
    }
  })
}
